import React, { useEffect, useState } from "react";
import axios from "axios";

import {
  Container,
  Typography,
  Box,
  Button,
  Stack,
  Tooltip
} from "@mui/material";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Link
} from "@mui/material";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CampaignIcon from "@mui/icons-material/Campaign";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import ScrollTopButton from "../../components/ScrollTopButton";

const Showdoc = () => {
  let xURL = "";
  let xlocation = window.location.hostname;

  if (xlocation === "localhost") {
    xURL = "http://localhost:3001/api/";
  } else {
    xURL = "https://sau.rihes.cmu.ac.th/api/";
  }

  const [zhead, _zhead] = useState("");
  const [zorder, _zorder] = useState("");

  var url = new URL(window.location.href);

  const [fileList, _fileList] = useState([""]);

  // const fileList = [
  //   { name: "รายงานการประชุม_ทดสอบ.pdf", url: "/files/report.pdf" },
  //   { name: "โครงการใหม่_ทดสอบ.docx", url: "/files/project.docx" }
  // ];

  useEffect(() => {
    if (url.searchParams.get("order") === "1") {
      _zhead("รายงานวิจัย");
      _zorder("1");

      Find_doc("รายงานวิจัย");
    } else if (url.searchParams.get("order") === "2") {
      _zhead("บทความ / บทสรุปผู้บริหาร");
      _zorder("2");

      Find_doc("บทความ / บทสรุปผู้บริหาร");
    } else if (url.searchParams.get("order") === "3") {
      _zhead("หนังสือ");
      _zorder("3");

      Find_doc("หนังสือ");
    } else if (url.searchParams.get("order") === "4") {
      _zhead("Infographic");
      _zorder("4");

      Find_doc("Infographic");
    } else if (url.searchParams.get("order") === "5") {
      _zhead("เกม");
      _zorder("5");

      Find_doc("เกม");
    }
  }, []);

  const Find_doc = title => {
    axios
      .post(xURL + "find_doc", { title: title })
      .then(result => {
        ShowDoc(result.data);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const ShowDoc = zdata => {
    const Tb1 = [];

    zdata.forEach((i, idx) => {
      Tb1.push({
        name: i.name,
        url: i.cmu_to_link
      });
    });

    _fileList(Tb1);
  };

  // ฟังก์ชันแบ่ง array ออกเป็นกลุ่มย่อยขนาด n
  const chunkArray = (array, size) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  };

  const chunkedFiles = chunkArray(fileList, 10);

  // หาจำนวนแถวสูงสุด (10)
  const maxRows = 10;

  // Handlers for bingo buttons (placeholders)
  const handleBingoInfo = () => {
    // console.log("บิงโก info ถูกกด");
    // TODO: navigate/open modal for "จะเกิดอะไรขึ้นเมื่อเด็ก-เยาวชนเสพกัญชา"
    window.open("/bingo1", "_self");
  };

  const handleBingoGame = () => {
    // console.log("เกมบิงโกปอดไม่แหก ถูกกด");
    // TODO: navigate/start the bingo game
    window.open("/bingo2", "_self");
  };

  return (
    <React.Fragment>
      <Navbar />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh" // ทำให้สูงเท่าหน้าจอ
        }}
      >
        <Container sx={{ textAlign: "center", maxWidth: "md" }}>
          <Typography
            gutterBottom
            sx={{
              mt: 18,
              fontWeight: 700,
              fontFamily: "Poppins, sans-serif",
              textAlign: "center",
              background: "linear-gradient(90deg, #3F51B5, #00BCD4)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "1.4rem", sm: "1.6rem", md: "1.8rem" },
              textShadow: "1px 1px 2px rgba(0,0,0,0.08)",
              letterSpacing: "0.8px",
              lineHeight: 1.4
            }}
          >
            {zhead}
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              mt: 4,
              gap: 3
            }}
          >
            <TableContainer
              component={Paper}
              sx={{
                maxWidth: 800,
                p: 2,
                backdropFilter: "blur(12px)",
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.7), rgba(200, 230, 255, 0.6))",
                borderRadius: 4,
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                transition: "all 0.3s ease",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, rgba(255,255,255,0.85), rgba(220, 240, 255, 0.75))",
                  boxShadow: "0 12px 32px rgba(0,0,0,0.18)"
                }
              }}
            >
              <Table>
                <TableBody>
                  {Array.from({ length: 10 }) // max 10 rows
                    .filter((_, rowIndex) =>
                      chunkedFiles.some(chunk => chunk[rowIndex] !== undefined)
                    )
                    .map((_, rowIndex) =>
                      <TableRow key={rowIndex}>
                        {chunkedFiles.map((chunk, colIndex) =>
                          <TableCell
                            key={colIndex}
                            sx={{
                              transition: "all 0.2s ease-in-out",
                              "&:hover": {
                                backgroundColor: "rgba(0, 188, 212, 0.08)",
                                transform: "scale(1.005)"
                              }
                            }}
                          >
                            {chunk[rowIndex]
                              ? <b>
                                  <a
                                    href={chunk[rowIndex].url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#000",
                                      textDecoration: "none"
                                    }}
                                  >
                                    {chunk[rowIndex].name}
                                  </a>
                                </b>
                              : null}
                          </TableCell>
                        )}
                      </TableRow>
                    )}
                </TableBody>
              </Table>
            </TableContainer>

            {zorder == 5
              ? <Stack
                  direction="column"
                  spacing={2}
                  sx={{ alignItems: "center" }}
                >
                  <Tooltip title="บิงโก “จะเกิดอะไรขึ้นเมื่อเด็ก-เยาวชนเสพกัญชา”">
                    <Button
                      variant="contained"
                      startIcon={<CampaignIcon />}
                      onClick={handleBingoInfo}
                      sx={{
                        width: 320,
                        height: 64,
                        bgcolor: "#d32f2f",
                        color: "#fff",
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: { xs: "0.85rem", sm: "0.95rem" },
                        boxShadow: "0 10px 30px rgba(211,47,47,0.18)",
                        "&:hover": { bgcolor: "#c62828" }
                      }}
                    >
                      บิงโก “จะเกิดอะไรขึ้นเมื่อเด็ก-เยาวชนเสพกัญชา”
                    </Button>
                  </Tooltip>

                  <Tooltip title="เกมบิงโกปอดไม่แหก">
                    <Button
                      variant="outlined"
                      startIcon={<SportsEsportsIcon />}
                      onClick={handleBingoGame}
                      sx={{
                        width: 320,
                        height: 64,
                        color: "#1976d2",
                        borderColor: "rgba(25,118,210,0.3)",
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: { xs: "0.85rem", sm: "0.95rem" },
                        boxShadow: "0 8px 24px rgba(25,118,210,0.12)",
                        "&:hover": { bgcolor: "rgba(25,118,210,0.04)" }
                      }}
                    >
                      เกมบิงโกปอดไม่แหก
                    </Button>
                  </Tooltip>
                </Stack>
              : <div />}
          </Box>
        </Container>

        <ScrollTopButton />
      </Box>

      <Footer />
    </React.Fragment>
  );
};

export default Showdoc;
